import React from 'react';

export default function GradientButton({ children, disabled, className = '', style = {}, ...props }) {
  return (
    <button
      {...props}
      disabled={disabled}
      className={`inline-flex items-center gap-2 px-5 py-2 text-sm font-semibold rounded-xl text-white transition-all disabled:opacity-50 ${className}`}
      style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)', ...style }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.9'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
    >
      {children}
    </button>
  );
}
